export default __webpack_public_path__ + "static/media/BetWon-Notification.1934d097.svg";